import React, { useEffect, useState } from 'react';
import './Cambcontra.css';
import Logoicono from '../Componentes/logosvg2';
import axios from 'axios';
import {toast, Toaster} from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';


function Cambcontra() {
axios.defaults.withCredentials = true;
const [solicitud, setSolicitud] = useState();
const [datos, setDatos] = useState({
    correo: '',
    nuecontra: '',
    repcontra: ''
})
const [correo, setCorreo] = useState('');
const navigate = useNavigate();
const params = new URLSearchParams(window.location.search);
const token = params.get("a");

useEffect(() => {
    if (token) {
        console.log(token)
        axios.get(`${process.env.REACT_APP_HTTPS}/api/estable/chkcambiarcontra`, {params: { a: token }})
        .then(response => {
            if (response.data.success === true){
                setCorreo(response.data.correo);
                setSolicitud(true);
            } else if (response.data.success === false){
                console.log(response.data.message);
                setSolicitud(false);
                toast.error('Correo expirado',{position: 'top-right'})
            }
        })
        .catch(error => {
            console.error('No existe el token:', error);
            toast.error('Error al enviar el correo', {position: 'top-center'});
            return ; 
        });
      } else {
        setSolicitud(false);
      }
},[])

const captureInp = (e) =>{
    e.persist();
    setDatos({...datos, [e.target.name]: e.target.value});
};

const SolicitarCorreo = () => {
    if (datos.correo === ''){
        toast.error('Coloca tu correo electronico', {position: 'top-center'})
        return
    }
    axios.post(`${process.env.REACT_APP_HTTPS}/api/estable/solicitarcambio`, {correo: datos.correo})
        .then(response => {
            if (response){
            toast.success('Te llegara el correo pronto', {position: 'top-center'});
            navigate('/');
        }
        })
        .catch(error => {
            console.error('Error al inciar sesion:', error);
            toast.error('Error al enviar el correo', {position: 'top-center'});
            return ; 
        });
}

const cambiarcontra = async () => {
    const contranueva = datos.nuecontra;
    const repeticion = datos.repcontra;
    if (contranueva != repeticion) { 
        toast.error('Las contraseñas no coinciden', {position:'top-center'})
        return
    };
    await axios.post(`${process.env.REACT_APP_HTTPS}/api/estable/cambiarcontra`,{new: contranueva, correo: correo, a: token})
    .then(response => {
        if (response){
            toast.success('Contraseña actualizada exitosamente', {position:'top-center'});
            navigate('/')
        }
    }).catch(error =>
        {   
            console.error('Error en el axios', error);
            return
        }
        
    )
}


  return (
    <div className='Camb_contenedor'>
        <div className='Ltitulo'><div className='Llogotitulo'><Logoicono/></div>
        <p onClick={() => navigate('/')} style={{cursor:'pointer', color: 'white', fontSize: '40px', marginTop:'7px'}}>Chamuscón</p></div>
        {solicitud === false ? 
        (<><div className="Camb_cambio">
            <h2>Cambio de contraseña</h2>
            <p>Ingresa tu correo electrónico asociado</p>
            <input type='email' onChange={captureInp} name='correo'/>
            <button onClick={SolicitarCorreo}>Solicitar cambio</button>
            <br/>
            <p>Te llegara un correo para el cambio de contraseña</p>
        </div></>): 
        
        solicitud === true ? 
        (<>
        <div className="Camb_cambio">
            <h2>Cambio de contraseña</h2> <br/>
                <p>Nueva contraseña: </p>
                <input className="loguser" onChange={captureInp} type="password" name="nuecontra" required /> <br />
                <p>Repetir contraseña: </p>
                <input className="logpass" onChange={captureInp} type="password" name="repcontra" required /> <br />
                <button onClick={cambiarcontra}>Cambiar contraseña</button> <br/>
        </div></>)
        :(<>Solicitud invalida</>)}
        <Toaster/>
    </div>
  )
}

export default Cambcontra